import z from 'zod';
import {
  coerceBoolean,
  coerceLiteralNumberRequired,
  coerceOptionalPositiveNumber,
  FIRST_VERSION_TIMESTAMP,
  ZodVersionedMetadata
} from '~/lib/zod';
import { TenantCustomer } from '~/tenants/common/TenantPersona';
import { DisplayData } from '~/lib/model';

export const MpiCustomerSchema = {
  [FIRST_VERSION_TIMESTAMP]: z.object({
    version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),

    discount_flyer_25: coerceOptionalPositiveNumber(),
    discount_flyer_50: coerceOptionalPositiveNumber(),
    discount_brochure_2_25: coerceOptionalPositiveNumber(),
    discount_brochure_2_50: coerceOptionalPositiveNumber(),
    discount_brochure_4_25: coerceOptionalPositiveNumber(),
    discount_brochure_4_50: coerceOptionalPositiveNumber(),
    discount_brochure_8_25: coerceOptionalPositiveNumber(),
    discount_brochure_8_50: coerceOptionalPositiveNumber(),
    discount_aerial_video: coerceOptionalPositiveNumber(),
    discount_aerial_photo: coerceOptionalPositiveNumber(),
    discount_photography: coerceOptionalPositiveNumber(),
    discount_print: coerceOptionalPositiveNumber(),
    discount_gas: coerceBoolean().optional(),
    disable_bundle_discount: coerceBoolean().optional(),
    provider_increase: z.coerce.number().optional(),
  }),
};

export type MpiCustomerMetadata = ZodVersionedMetadata<typeof MpiCustomerSchema>;

export default class MpiCustomer extends TenantCustomer<MpiCustomerMetadata> {
  get info(): DisplayData[] {
    const info = super.info;

    return info;
  }
}
